import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";
import TopIf from "../../../../../componentsTopsa/if/TopIf";

export default class EPrzystankiTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.formatPrzystanekOd = this.formatPrzystanekOd.bind(this)
        this.formatPrzystanekDo = this.formatPrzystanekDo.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj eprzystanek'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń eprzystanek'}/>
            </div>
        )
    }

    formatPrzystanekOd(cell, row) {
        let czyRezerw = false;
        if (row.przystanki.find(p => Boolean(p.rezerwacja) == true)) {
            czyRezerw = true
        }

        return (
            <span title={Boolean(czyRezerw) ? 'Przystanek objęty możliwością rezerwacji' : 'Przystanek bez możliwości rezerwacji'}>
            <span className={Boolean(czyRezerw) ? 'label label-ebus-secondary' : 'label label-ebus-primary'}
                  style={{marginRight: '15px'}}>{cell.nazMi}</span>
            <span>{cell.nazPr}</span>
             <TopIf isTrue={czyRezerw}>
                <span style={{marginLeft: '5px'}}><i className={'fa fa-flag'} style={{color: "#132239"}}></i></span>
            </TopIf>
        </span>)
    }

    formatPrzystanekDo(cell, row) {
        return (<div>
            {
                cell.map(item => {
                    return (
                        <span style={{marginRight: '15px'}}>
                            {
                                Boolean(item.rezerwacja) ?
                                    <span className={'label label-ebus-secondary'}>{item.nazMi}</span>
                                    :
                                    <span className={'label label-ebus-primary'}>{item.nazMi}</span>
                            }
                            <span style={{marginLeft: '5px'}}>
                                {item.nazPr}
                            </span>
                            <TopIf isTrue={item.rezerwacja}>
                                <span className={'fa fa-flag'} style={{marginLeft: '5px', color: "#132239"}}></span>
                            </TopIf>
                            ,
                        </span>
                    )
                })
            }
        </div>)
    }


    render() {

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <div style={{clear: 'both', padding: '15px 0'}}>
                    <div className={'pull-left'}>
                        <h4>{Boolean(this.props.trasa) ? this.props.trasa.nazTr : ''}</h4>
                    </div>
                    <div className={'pull-right'}>
                        <span>
                            <span className={'label label-ebus-primary'}>Miasto</span>
                            <span style={{marginLeft: '5px'}}>Przystanek bez możliwości rezerwacji</span>
                        </span>
                        <span style={{margin: '0 15px', color: '#ddd'}}>|</span>
                        <span>
                            <span className={'label label-ebus-secondary'}>Miasto</span>
                            <span style={{margin: '0 5px'}}>Przystanek objęty możliwością rezerwacji</span>
                            <i className="fa fa-flag" style={{color: "#132239"}}></i>
                        </span>
                    </div>
                </div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover

                >
                    <TableHeaderColumn dataField='idBz' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='przystanekOd' dataSort
                                       thStyle={tabgrid.tg7} tdStyle={tabgrid.tg7}
                                       dataFormat={this.formatPrzystanekOd}
                    >Nazwa przystanku od</TableHeaderColumn>
                    <TableHeaderColumn dataField='przystanki' dataSort
                                       thStyle={tabgrid.tg16} tdStyle={tabgrid.tg16}
                                       dataFormat={this.formatPrzystanekDo}
                    >Nazwa przystanków do</TableHeaderColumn>
                    <TableHeaderColumn dataField='idBz'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/ePrzystanki/components/EPrzystankiTable.js